import { render, staticRenderFns } from "./ProjectCounterparts.vue?vue&type=template&id=898d8dc8&scoped=true&"
import script from "./ProjectCounterparts.vue?vue&type=script&lang=js&"
export * from "./ProjectCounterparts.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCounterparts.vue?vue&type=style&index=0&id=898d8dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d8dc8",
  null
  
)

export default component.exports